module.exports = __webpack_public_path__ + "static/media/noodlesVermicelli.5f27ba6a.webp";